var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceDock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16zm0 1.5H4a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h2.639a7 7 0 1110.723 0H20a.5.5 0 00.5-.5V6a.5.5 0 00-.5-.5zm-8 3a5.5 5.5 0 00-3.163 10h6.325A5.5 5.5 0 0012 8.5zm2.026 6.919a.75.75 0 01.954 1.157l-.002.002-.002.001-.004.004-.013.01-.067.051a3.203 3.203 0 01-.482.283c-.335.16-.82.323-1.41.323a3.288 3.288 0 01-1.924-.63l-.035-.027-.013-.01-.004-.004-.003-.002.103-.125-.104.124a.75.75 0 01.954-1.157l.05.035a1.788 1.788 0 00.976.296 1.788 1.788 0 001.021-.328l.005-.003zM11 12a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z",
    fill: "currentColor"
  })));
}

export default SvgFaceDock;